<template>
  <div v-show="show">
    <FormKit
      :help-position="helpPosition"
      :help="field.instructions"
      :label-position="labelPosition"
      :label="field.name"
      :multiple="field.multi"
      :name="name"
      :options="options"
      :placeholder="field.placeholder"
      :size="field.multi && field.options.length ? field.options.length : 1"
      :validation="validation"
      :value="value"
      type="select"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldDefaultOptions, fieldHelpPosition, fieldLabelPosition, fieldName, fieldOptions, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: object
  parentField?: object
  field: object
}

const props = defineProps<Props>()

const helpPosition = fieldHelpPosition(props.settings, props.field)
const labelPosition = fieldLabelPosition(props.settings, props.field)
const name = fieldName(props.field, props.parentField)
const options = fieldOptions(props.field)
const show = fieldVisible(props.field)
const validation = fieldValidationArray(props.field)
const value = props.field.multi ? fieldDefaultOptions(props.field) : fieldDefaultOptions(props.field)?.[0]
</script>
